// TODO: this probably should be a backend responsibility
export const AutoCloseEodCarrierIds = [
  '3',
  '5',
  '6',
  '8',
  '9',
  '10',
  '12',
  '14',
  '18',
  '24',
  '26',
  '28',
  '33',
  '35',
  '38',
  '39',
  '41',
  '42',
  '43',
];
export const ElectronicEodCarrierIds = ['7', '15', '16', '19', '29'];
export const doesCarrierAutoGenerateEod = (carrierId) => AutoCloseEodCarrierIds.indexOf(carrierId) !== -1;
export const doesCarrierUseElectronicEod = (carrierId) => ElectronicEodCarrierIds.indexOf(carrierId) !== -1;
